import { gql } from '@apollo/client';
import { PartnerUserInfoShared } from '../fragments';

export default gql`
  query partnerUser($id: ID) {
    partnerUser(id: $id) {
      ...PartnerUserInfoShared
      deletable
      notificationSettings {
        enabled
        notificationType {
          id
          name
          description
          symbol
        }
      }
    }
  }
  ${PartnerUserInfoShared}
`;
